import { createAlfaAuthUrl } from 'src/components/AuthNew/utils/createAlfaAuthUrl';
import { getSocialAuthConfigByName } from 'src/components/AuthNew/utils/socialNetworkUtils';
import type { AlfaAuthConfig } from 'src/components/AuthNew/utils/socialNetworkUtils';

export const AlfaWebviewHandler = () => {
  try {
    // Получаем конфигурацию для Альфа-Банка
    const config = getSocialAuthConfigByName('alfabank') as AlfaAuthConfig;

    if (!config) {
      throw new Error('Конфигурация для Альфа-Банка не найдена');
    }

    config.redirectURI = `${window.location.origin}`;

    const validationState = String(Math.floor(Math.random() * 1000000000));
    const authURL = createAlfaAuthUrl(config, validationState, true);
    window.location.assign(authURL);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('AlfaWebviewHandler: ошибка', error);
  }
};
